<div class="detail-card" [nbSpinner]="this.isLoading">
  <div class="card-bar">
    <h3>Orders</h3>
    <span class="count-pill">{{this.orders.length}}</span>
  </div>

  <div class="card-empty" *ngIf="!this.isLoading && !this.orders.length">No orders have selected this lot.</div>

  <ng-container *ngIf="this.orders.length">
    <div class="card-grid clickable">
      <ejs-grid [dataSource]="this.orders" [columns]="this.columns" [allowPaging]="true" [pageSettings]="this.pageSettings"
        [allowFiltering]="true" [filterSettings]="this.filterSettings" [allowSorting]="true" [allowTextWrap]="true"
        [enableHover]="true" (rowSelected)="onRowSelected($event)">
      </ejs-grid>
    </div>

    <div class="kw-mobile-list">
      <div class="card-row clickable" *ngFor="let order of this.orders; trackBy: trackByOrder" (click)="openOrder(order)">
        <div class="card-row-top">
          <span class="card-row-name">{{order.breweryName}}</span>
          <span class="type-pill" *ngIf="order.status">{{order.status}}</span>
        </div>
        <span class="card-row-sub">
          {{order.orderNumber}}<ng-container *ngIf="formatDate(order.scheduledShipDate) as shipDate"> · ships {{shipDate}}</ng-container><ng-container *ngIf="order.salesRep"> · {{order.salesRep}}</ng-container>
        </span>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #actionTemplate let-data>
  <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
</ng-template>
